import { Box, Typography, TextField, Button, InputAdornment, IconButton } from "@mui/material"
import { useTheme } from "@mui/material/styles"
import { useScheduled } from "../../../../shared/context/scheduledContext"
import { useForm, Controller } from "react-hook-form"
import { useUtiles } from "../../../../shared/context/utilesContext"
import SelectAssetComponent from "../SelectAssetComponent"
import ClearIcon from '@mui/icons-material/Clear'
import { useEffect, useRef } from "react"
import { useParams } from "react-router"
import { useAbility } from "../../../../shared/context/AbilityContext"

export default function ProgramacionComponent() {
    const theme = useTheme()
    const { groupScheduled, setGroupScheduled, createGroupScheduled, setSelectAsset, getGroupScheduledByHash, updateGroupScheduled } = useScheduled()
    const { control, handleSubmit, formState: { errors }, setValue } = useForm()

    const { openSilderWith, locationString } = useUtiles()

    const { code_group } = useParams()

    const ability = useAbility();


    useEffect(() => {
        if (!ability.can('create', 'SCHEDULED.PLANNING')) {
            navigate('/')
        }
    }, [ability])

    
    useEffect(() => {
        console.log(errors)
    }, [errors])    
    

    const firstRender = useRef(true)
    /*
    useEffect(() => {
        const fetchAndSetData = async () => {
            if (code_group) {
                await getGroupScheduledByHash(code_group);
            }
        };
        
        fetchAndSetData();
    }, [code_group]);  


    */

    useEffect(() => {
        if (groupScheduled.name) {
            setValue('name', groupScheduled.name);
            setValue('description', groupScheduled.description);
            setValue('asset', groupScheduled.asset);
        }
    }, [groupScheduled, setValue]);

    const handleChangeField = (field, value) => {
        setValue(field, value)
        setGroupScheduled({ ...groupScheduled, [field]: value })
    }

    const handleSelectAsset = (asset) => {
        setSelectAsset(asset)
        setGroupScheduled({ ...groupScheduled, asset: asset })
        setValue('asset', asset)
    }

    const handleCreateGroupScheduled = () => {
        if (code_group) {
            updateGroupScheduled()
        } else {
            createGroupScheduled()
        }
    }

    return (
        <Box> 
            <form onSubmit={handleSubmit(handleCreateGroupScheduled)}>

            <Box sx={{ p: { xs: 0.5, md: 2 }, pb: { xs: 0, md: 0 } }}>
                <Typography variant="subtitle2" sx={{ fontWeight: 'bold', fontSize: '12px', color: theme.palette.text.primary, mb: 1 }}>Nombre del grupo programado:</Typography>
                <Controller
                    control={control}
                    name="name"
                    rules={{
                        required: 'Este campo es requerido',
                    }}
                    render={({ field }) => (
                        <TextField
                            fullWidth
                            value={groupScheduled.name || ""}
                            placeholder="Ingrese el nombre del grupo programado"
                            error={!groupScheduled.name }
                            helperText={!groupScheduled.name ? 'Este campo es requerido' : ''}
                            onChange={(e) => handleChangeField('name', e.target.value)}
                        />
                    )}
                />

            </Box>
            <Box sx={{ p: { xs: 0.5, md: 2 }, pb: { xs: 0, md: 0 } }}>
                <Typography variant="subtitle2" sx={{ fontWeight: 'bold', fontSize: '12px', color: theme.palette.text.primary, mb: 1 }}>Descripción de la programación:</Typography>
                <Controller
                    control={control}
                    name="description"
                    render={({ field }) => (
                        <TextField
                            fullWidth
                            value={groupScheduled.description || ""}
                            placeholder="Ingrese la descripción"
                            onChange={(e) => handleChangeField('description', e.target.value)}
                        />
                    )}
                />

            </Box>

            <Box sx={{ p: { xs: 0.5, md: 2 }, pb: { xs: 0, md: 0 } }}>
                <Typography variant="subtitle2" sx={{ fontWeight: 'bold', fontSize: '12px', color: theme.palette.text.primary, mb: 1 }}>Seleccione el activo:</Typography>
                <Controller
                    control={control}
                    name="asset"
                    rules={{ required: 'Este campo es requerido' }}
                    render={({ field }) => (
                        <TextField 
                        disabled={code_group}
                        fullWidth 
                        placeholder="Seleccione el activo" 
                        onClick={() => {
                            openSilderWith(<SelectAssetComponent functionSelect={handleSelectAsset} />, 500, 'Seleccionar activo')
                        }}

                        InputProps={{
                            readOnly: true,
                            endAdornment: groupScheduled.asset && !code_group && (
                                <InputAdornment position="end">
                                    <IconButton 
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            setGroupScheduled({ ...groupScheduled, asset: null });
                                            setValue('asset', null);
                                        }}
                                        size="small"
                                    >
                                        <ClearIcon />
                                    </IconButton>
                                </InputAdornment>
                            )
                        }}
                        value={locationString(groupScheduled.asset)}
                        error={!groupScheduled.asset} 
                        helperText={!groupScheduled.asset ? 'Este campo es requerido' : ''}
                        />
                        
                    )}
                />
            </Box>

            <Box sx={{ p: { xs: 0.5, md: 2 }, pb: { xs: 0, md: 2 } }}>
                <Button type="submit" variant="contained" color="primary">{code_group ? 'Actualizar' : 'Crear'} y continuar</Button>
            </Box>
            </form>
        </Box>
    )
} 